import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { DOLLAR_IMG, useDollar } from "@/lib/dollar";

export function DollarGrownDialog() {
  const { state } = useDollar();
  const [closed, setClosed] = useState(false);
  const close = () => {
    setClosed(true);
    api.post("/mentor/dollar/seen").catch(() => undefined);
  };
  const open = !!state?.show_grown && !closed;
  return (
    <Dialog open={open} onOpenChange={(o: boolean) => { if (!o) close(); }}>
      <DialogContent className="max-w-md rounded-[24px] border-[#E7DECF] bg-[#FAF7F1] p-8 text-center" data-testid="dollar-grown-dialog">
        <img src={DOLLAR_IMG.adult.full} alt="Dollar adulto" className="mx-auto h-56 w-auto" />
        <DialogTitle className="screen-title !text-[28px]">Dollar creció</DialogTitle>
        <DialogDescription className="text-base text-[#1A1F2B]">
          Llevas 3 meses seguidos registrando tus movimientos y haciendo crecer tu ahorro, con tu presupuesto armado. Esa constancia es lo que hace la diferencia.
        </DialogDescription>
        <Button onClick={close} className="mx-auto mt-2 h-11 px-8" data-testid="dollar-grown-continue">Continuar</Button>
      </DialogContent>
    </Dialog>
  );
}
